import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const MonthlyPerformances = React.lazy(() => import('./index'));
const MpTable = React.lazy(() => import('./mpTable'));
const MonthlyPerformance = React.lazy(() => import('./monthlyPerformance'));
const MpDetail = React.lazy(() => import('./mpDetail'));
const AddNewMonthlyPerformance = React.lazy(() => import('./addNewMonthlyPerformance'));
const EditMonthlyPerformance = React.lazy(() => import('./editMonthlyPerformance'));

export const useMonthlyPerformanceRoutes = () => {
    return (
        <React.Fragment>
            <Route path="monthlyPerformance" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyPerformances isCumulative={false} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MpTable isCumulative={false}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewMonthlyPerformance isCumulative={false}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyPerformance isCumulative={false}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MpDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditMonthlyPerformance /></Suspense> } />
                </Route>
            </Route>
            <Route path="cumulativeMonthlyPerformance" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyPerformances isCumulative={true} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MpTable isCumulative={true}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewMonthlyPerformance isCumulative={true}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyPerformance isCumulative={true}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MpDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditMonthlyPerformance /></Suspense> } />
                </Route>
            </Route>
        </React.Fragment>
    )
}